import {
  LowestPriceAssuranceSideLine,
  LowestPriceAssuranceSparkle
} from '../../../icons/LowestPriceAssuranceIcons'

export function LowestPriceAssurance({ title }: { title: string }) {
  return (
    <h2 className='flex w-full items-center'>
      <LowestPriceAssuranceSideLine />
      <span className='mx-0 flex shrink-0 items-center gap-1.5 px-2.5 py-1 text-13 font-medium leading-none tracking-[0.01em] text-[color:var(--ep-plus-strong)]'>
        <LowestPriceAssuranceSparkle />
        <span>{title}</span>
        <LowestPriceAssuranceSparkle />
      </span>
      <LowestPriceAssuranceSideLine />
    </h2>
  )
}
